import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import ErrorPage from "./ErrorPage";

const NotFoundPage = observer(props => <ErrorPage {...props} />);

NotFoundPage.propTypes = {
  title: PropTypes.string,
  helpText: PropTypes.string,
  continueUrl: PropTypes.string,
  continueText: PropTypes.string,
};

NotFoundPage.defaultProps = {
  title: "404 Not Found",
  helpText: "Sorry, the page you were looking for could not be found.",
};

export default NotFoundPage;
